import "#packages/ecma402-abstract/types/date-time.js";
import "#packages/ecma402-abstract/DateTimeFormat/FormatDateTimePattern.js";
import { PartitionDateTimeRangePattern } from "#packages/ecma402-abstract/DateTimeFormat/PartitionDateTimeRangePattern.js";
import "#packages/ecma402-abstract/DateTimeFormat/ToLocalTime.js";
export function FormatDateTimeRangeToParts(dtf, x, y, implDetails) {
	const parts = PartitionDateTimeRangePattern(dtf, x, y, implDetails);
	const result = [];
	for (const part of parts) {
		result.push({
			type: part.type,
			value: part.value,
			source: part.source
		});
	}
	return result;
}
